import data from './data';
import useTranslation from '@Queries/useTranslation';
import CollectionBenefit from './CollectionBenefit';

import type { FC, HTMLAttributes } from 'react';
import type { CollectionBenefitText } from './CollectionBenefit';

type CollectionBenefitsProps = HTMLAttributes<HTMLDivElement>;

const CollectionBenefits: FC<CollectionBenefitsProps> = (props) => {
  const { t } = useTranslation();
  const text1: CollectionBenefitText = {
    first: {
      title: t('collection-benefits.1.first.title'),
      description: t('collection-benefits.1.first.description'),
      link: t('collection-benefits.1.first.link'),
    },
    second: {
      title: t('collection-benefits.1.second.title'),
      description: t('collection-benefits.1.second.description'),
      link: t('collection-benefits.1.second.link'),
    },
  };

  const text2: CollectionBenefitText = {
    first: {
      title: t('collection-benefits.2.first.title'),
      description: t('collection-benefits.2.first.description'),
      link: t('collection-benefits.2.first.link'),
    },
    second: {
      title: t('collection-benefits.2.second.title'),
      description: t('collection-benefits.2.second.description'),
      link: t('collection-benefits.2.second.link'),
    },
  };

  return (
    <div {...props}>
      <CollectionBenefit data={data[0]} text={text1} />
      <CollectionBenefit data={data[1]} text={text2} />
    </div>
  );
};

export default CollectionBenefits;
